import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex items-center gap-2"
}

import { MenuItem } from "@headlessui/vue";
import { CheckIcon } from "@heroicons/vue/24/outline";
import { PencilIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import { computed, nextTick, ref } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { useTrackEvent } from "shared/composables/tracking";
import LiveBase from "@/components/live_video/LiveBase.vue";
import { useStreams, useUpdateStreams } from "@/composables/stream";
import { Dashboard } from "@/types/Dashboard";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";
import { useVideoPlayerDimensions } from "@/views/dashboard/composables";
import { liveStreamWidgetHeaderHeight } from "@/views/dashboard/services/projectOverviewV2Layout";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveStreamWidget',
  props: {
    arg: {},
    width: {},
    height: {},
    dashboard: {}
  },
  emits: ["delete", "widgetRouteClicked", "trackInteraction"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isRenaming = ref(false);
const nameEditingValue = ref("");
const nameEditingInput = ref<HTMLInputElement | null>(null);

const { streams } = useStreams();
const { updateStreams, isUpdateLoading } = useUpdateStreams();

const stream = computed(() => streams.value.find(({ camera_id }) => camera_id === props.arg));

const containerRef = ref<HTMLDivElement | null>(null);

const playerDimensions = useVideoPlayerDimensions(containerRef);

const handleEditNameClick = () => {
  if (!stream.value) {
    return;
  }
  isRenaming.value = true;
  nameEditingValue.value = stream.value.name;
  nextTick(() => {
    if (nameEditingInput.value) {
      nameEditingInput.value?.focus();
    }
  });
};

const trackEvent = useTrackEvent();

const handleConfirmNameClick = () => {
  if (!stream.value) {
    return;
  }
  const updatedStream = {
    _id: stream.value._id,
    name: nameEditingValue.value || stream.value.name,
  };

  trackEvent("dashboard_widget_stream-rename_apply");
  updateStreams([updatedStream]).catch(() => undefined);
};

const resetNameEditing = () => {
  isRenaming.value = false;
  nameEditingValue.value = "";
};
const routerConnectionLost = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseWidget, {
    onDelete: _cache[5] || (_cache[5] = ($event: any) => (emit('delete'))),
    hideDragHandle: "",
    menuClass: "top-4",
    onTrackInteraction: _cache[6] || (_cache[6] = ($event: any) => (emit('trackInteraction')))
  }, {
    menuItems: _withCtx(() => [
      (_ctx.hasPermission('project_admin') && _ctx.dashboard?.type === 'project')
        ? (_openBlock(), _createBlock(_unref(MenuItem), {
            key: 0,
            onClick: handleEditNameClick
          }, {
            default: _withCtx(({ active }) => [
              _createElementVNode("div", {
                class: _normalizeClass([
            active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
            'px-4 py-2 text-sm cursor-pointer truncate flex items-center gap-2',
          ])
              }, [
                _createVNode(_unref(PencilIcon), { class: "w-4 h-4" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("camera.dashboard.rename")), 1)
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "h-full flex flex-col",
        ref_key: "containerRef",
        ref: containerRef
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle({ height: `${_unref(liveStreamWidgetHeaderHeight)}px` })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["pl-4 pr-7 flex items-center py-4 gap-2", {
            'bg-red-100': routerConnectionLost.value,
          }])
          }, [
            _createVNode(DashboardDragHandle, { class: "shrink-0" }),
            (stream.value && !isRenaming.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: {
              name: 'Live',
              params: {
                camera_id: stream.value.camera_id,
                customer_name: stream.value.customer_name,
                site_id: stream.value.site_id,
              },
            },
                  class: "font-semibold text-gray-900 truncate text-lg hover:text-yellow-800",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('widgetRouteClicked')), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(stream.value?.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (isRenaming.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "nameEditingInput",
                    ref: nameEditingInput,
                    type: "text",
                    autocomplete: "one-time-code",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nameEditingValue).value = $event)),
                    onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: [
                      _withKeys(handleConfirmNameClick, ["enter"]),
                      _withKeys(resetNameEditing, ["esc"])
                    ],
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                    maxlength: "1000",
                    class: "block rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-yellow-600 sm:text-sm sm:leading-6"
                  }, null, 544), [
                    [_vModelText, nameEditingValue.value]
                  ]),
                  (!_unref(isUpdateLoading))
                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                        key: 0,
                        class: "w-5 h-5 cursor-pointer text-gray-600 hover:text-yellow-600 shrink-0",
                        onClick: _withModifiers(handleConfirmNameClick, ["stop"])
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(isUpdateLoading))
                    ? (_openBlock(), _createBlock(_unref(XMarkIcon), {
                        key: 1,
                        class: "w-5 h-5 cursor-pointer text-gray-600 hover:text-yellow-600 shrink-0",
                        onClick: _withModifiers(resetNameEditing, ["stop"])
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isUpdateLoading))
                    ? (_openBlock(), _createBlock(LoadingSpinner, {
                        key: 2,
                        size: "w-5 h-5"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ height: `${_unref(playerDimensions).height}px` }),
          class: "bg-oaiGray-900 flex flex-col items-center",
          "data-oai-left-over-space-calculator": "ignore"
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({
            width: `${_unref(playerDimensions).width}px`,
          }),
            class: "overflow-hidden"
          }, [
            _createVNode(LiveBase, {
              cameraId: _ctx.arg,
              addRightSpaceToControlBar: true,
              onVideoHasError: _cache[4] || (_cache[4] = ($event: any) => (routerConnectionLost.value = true))
            }, null, 8, ["cameraId"])
          ], 4)
        ], 4)
      ], 512)
    ]),
    _: 1
  }))
}
}

})